import personTemplate from "./Person.hbs";

(function () {
    if (document.querySelectorAll(".js-person-listing-page").length > 0) {

        const personListingPage = {
            init: function () {
                personListingPage.addEventListeners();
            },
            addEventListeners: () => {
                const cards = document.querySelectorAll(".personlisting__link");

                cards.forEach((card) => {
                    card.addEventListener("click", (event) => {
                        event.preventDefault();

                        if (event.target.id !== null) {
                            personListingPage.fetchData(event.target.id, false);
                        }
                    });
                });

                document.addEventListener("click", (e) => {
                    if (
                        e.target.nodeName === "MAIN" ||
                        e.target.classList.contains("js-person-modal-close")
                    ) {
                        personListingPage.closeModal();
                    }
                });

                document.onkeydown = function (e) {
                    const modal = document.getElementById("person-modal");
                    const isModalexpanded = modal.classList.contains("active")
                        ? true
                        : false;

                    if (isModalexpanded) {
                        if (e.keyCode == 27) {
                            personListingPage.closeModal();
                        }
                    }
                };
            },
            fetchData: (id, isOpen) => {
                const el = document.getElementById("person-modal");
                const labelPage = el.dataset.labelPage;
                const labelBiography = el.dataset.labelBiography;
                const labelNext = el.dataset.labelNext;

                fetch(`/api/persons/GetPerson?pageId=${id}`)
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        personListingPage.renderTemplate([
                            { PageLabel: labelPage },
                            { BiographyLabel: labelBiography },
                            { NextLabel: labelNext },
                            data,
                        ]);
                        personListingPage.clickNextPerson();
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        if (!isOpen) {
                            personListingPage.openModal();
                        }
                    });
            },
            renderTemplate: (data) => {
                const target = document.querySelector(".js-person-modal");

                if (target !== null) {
                    target.innerHTML = personTemplate(data);
                }
            },
            openModal: () => {
                const target = document.getElementById("person-modal");
                const main = document.getElementsByTagName("main");
                const html = document.getElementsByTagName("html");

                target.classList.add("active");
                target.setAttribute("aria-expanded", "true");

                main[0].classList.add("person__display");
                html[0].style.overflowY = "hidden";

                target.focus();
            },
            closeModal: () => {
                const target = document.getElementById("person-modal");
                const main = document.getElementsByTagName("main");
                const html = document.getElementsByTagName("html");

                target.classList.remove("active");

                main[0].classList.remove("person__display");
                html[0].style.overflowY = "auto";
                target.setAttribute("aria-expanded", "false");

                target.innerHTML = "";
            },
            clickNextPerson: () => {
                const target = document.querySelector(".js-person-next");

                if (target !== null) {
                    target.addEventListener("click", (e) => {
                        personListingPage.fetchData(e.target.id, true);
                    });
                }
            },
        };

        //personListingPage.init();
    }
})();
